<template>
  <el-dialog
    class="rc-dialog"
    :title="titleName"
    :visible.sync="dialogVisible.flag"
    v-if="dialogVisible.flag"
    width="700px"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="clearDept"
  >
    <el-transfer
      filterable
      :filter-method="filterMethod"
      filter-placeholder="请输入组织名称"
      v-model="value"
      :data="data"
      :props="{
        key: 'uuid',
        label: 'deptName',
      }"
      :titles="['组织名称', '已选组织']"
    >
    </el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-checkbox
        v-permission="'periodicalArticle:share:online'"
        class="m-r-12"
        v-model="needOnline"
        key="needOnline"
        :true-label="1"
        :false-label="0"
        >共享后直接上线
      </el-checkbox>
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="share">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Bus from "../Bus";
import { shareDeptList } from "@/api/dept";
import { saveArticleBatchShareList } from "@/api/resourceService";
export default {
  props: {
    dialogVisible: {
      type: Object,
      default: function () {
        return {
          idArr: [],
        };
      },
    },
  },
  data() {
    return {
      data: [],
      value: [],
      periodicals: [],
      titleName: "",
      needOnline: 0,
      filterMethod(query, item) {
        return item.deptName.indexOf(query) > -1;
      },
    };
  },
  created() {
      this.periodicals = this.dialogVisible.idArr;
      if (this.periodicals.length === 0) {
        this.titleName = "一键共享";
      } else {
        this.titleName = "共享";
      }
    shareDeptList().then((res) => {
      if (!res || res.code != 0) return;
      this.data = res.data;
    });
  },
  updated() {
    let doms = document.getElementsByClassName("el-checkbox__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    share() {
      if (this.value.length === 0) {
        this.$message({
          message: "请选择要共享的学院",
          type: "warning",
        });
      } else {
        saveArticleBatchShareList({
          uuids: this.periodicals,
          deptIds: this.value,
          needOnline: this.needOnline,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "期刊文章共享成功",
            type: "success",
          });
          this.$emit("closeDialog", true);
        });
      }
    },
    clearDept() {
      this.value = [];
      this.$emit("closeDialog", false);
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    }
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 330px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .m-r-12 {
    margin-right: 12px;
  }
}
</style>
